module.exports = __webpack_public_path__ + "static/puppy-training-in-chicago-b605fb646bf9edcd419bc0cb9b1a01ee.jpg";